<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12">
                <h1>Print Plate Support</h1>
            </b-col>
        </b-row>
        <b-card v-if="isUserSuperAdmin">
            <div slot="header">
                <strong>Current Chat Groups</strong>
            </div>
            <div v-if="!chatGroupsLoaded" class="form-container">
                <LoadingSpinner />
            </div>
            <div v-if="chatGroupsLoaded" class="form-container">
                <h4 class="mb-3" v-if="chatGroups.length > 0">For security and privacy reasons, all groups will be removed at midnight.</h4>
                <b-row v-if="chatGroups.length > 0">
                    <b-col v-for="group in chatGroups" cols="12" sm="12" md="6" v-bind:key="group.id">
                        <b-card :no-body="true" footer-class="px-3 py-2">
                            <b-card-body class="p-3 clearfix">
                                <i class="fa fa-user p-3 font-2xl mr-3 float-left"></i>
                                <div class="h5 text-warning mb-0">{{group.fullname}}</div>
                                <div class="text-muted text-uppercase font-weight-bold font-xs">{{group.company}} - {{group.site}}</div>
                                <div class="text-muted text-uppercase font-weight-bold font-xs">Created at: {{group.time}}</div>
                                <b-button class="close-chatgroup-button" variant="danger" @click="removeChatGroup(group.id)">
                                    <i class="fa fa-trash"></i>&nbsp;Delete Group
                                </b-button>
                            </b-card-body>
                            <div slot="footer">
                                <b-link class="font-weight-bold font-xs btn-block text-muted" @click="enterChatGroup(group.id)">Enter chat <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row v-if="chatGroups.length == 0">
                    <b-col>
                        <h4>There are no active chat groups at the moment.</h4>
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <b-card v-if="!isUserSuperAdmin">
            <div slot="header">
                <strong>Current Chat Group</strong>
            </div>
            <div v-if="!chatGroupsLoaded" class="form-container">
                <LoadingSpinner />
            </div>
            <div v-if="chatGroupsLoaded" class="form-container">
                <h4 class="mb-3" v-if="chatGroups.length > 0">For security and privacy reasons, all groups will be removed at midnight.</h4>
                <b-row v-if="chatGroups.length > 0">
                    <b-col v-for="group in chatGroups" cols="12" sm="12" md="12" v-bind:key="group.id">
                        <b-card :no-body="true" footer-class="px-3 py-2">
                            <b-card-body class="p-3 clearfix">
                                <i class="fa fa-user p-3 font-2xl mr-3 float-left"></i>
                                <div class="h5 text-warning mb-0">{{group.fullname}}</div>
                                <div class="text-muted text-uppercase font-weight-bold font-xs">{{group.company}} - {{group.site}}</div>
                                <div class="text-muted text-uppercase font-weight-bold font-xs">Created at: {{group.time}}</div>
                            </b-card-body>
                            <div slot="footer">
                                <b-link class="font-weight-bold font-xs btn-block text-muted" @click="enterChatGroup(group.id)">Enter chat <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row v-if="chatGroups.length == 0">
                    <b-col>
                        <h4>There are no active chat groups at the moment.</h4>
                        <div>
                            <b-button class="mt-2" variant="primary" @click="createChatGroup">
                                <i class="fa fa-plus"></i>&nbsp;Create
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>

import firebaseApp from '../../firebase';
import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    return {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Bearer ' + userObj.token,
      }
    };
}


export default {
  name: 'chatgroups',
  components: {
      LoadingSpinner: LoadingSpinner
  },
  data () {
    return {
        user: {},
        userAuthLevel: '',
        chatGroups: [],
        currentMessage: '',
        chatGroupsLoaded: false
    }
  },
  watch: {
  },
  mounted() {
      let self = this;
      const itemsRef = firebaseApp.database().ref('chatGroups');

      itemsRef.on('value', (snapshot) => {
          let data = snapshot.val();
          let chatGroups = [];
          console.log(data);
          if (data !== null) {
            Object.keys(data).forEach((key) => {
                
                const formatTime = ((milli) => {
                    const messageTime = new Date(milli);
                    const hours = messageTime.getHours().toString().length < 2 ? "0" + messageTime.getHours().toString() : messageTime.getHours().toString();
                    const minutes = messageTime.getMinutes().toString().length < 2 ? messageTime.getMinutes().toString() + "0" : messageTime.getMinutes().toString();
                    return hours + ":" + minutes;
                });
                
                chatGroups.push({
                    id: key,
                    username: data[key].username,
                    fullname: data[key].fullname,
                    auth: data[key].auth,
                    company: data[key].company,
                    site: data[key].site,
                    time: formatTime(data[key].timestamp)
                });
            });

            self.$data.chatGroups = chatGroups;
          }
          else {
            self.$data.chatGroups = [];
          }

          this.$data.chatGroupsLoaded = true;
      })
  },
  created () {
      this.$data.user = JSON.parse(localStorage.getItem('user'));
  },
  computed: {
    isUserSuperAdmin() {
        if (this.$data.user.auth == 'Super Admin') {
            return true;
        }
        else {
            return false;
        }
    },
  },
  methods : {
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    createChatGroup() {

        const group = {
            username: this.$data.user.username,
            fullname: this.$data.user.firstName + " " + this.$data.user.lastName,
            auth: this.$data.user.auth,
            company: this.$data.user.company_name,
            site: this.$data.user.site_name,
            timestamp: Date.now(),
            messages: []
        }
        // Push message to firebase
        firebaseApp.database().ref('chatGroups').push(group);
        
    },
    enterChatGroup(groupId) {
        this.$router.push({ path: `/chat/${groupId}` });
        console.log(groupId);
    },
    removeChatGroup(groupId) {
        firebaseApp.database().ref(`chatGroups/${groupId}`).remove();
    }
  }
}
</script>

<style scoped>

    .close-chatgroup-button {
        position: absolute;
        right: 5%;
        top: 15%;
    }
</style>